module.exports = __webpack_public_path__ + "img/money.fabe1704.svg";